import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import type { Competition } from "../../lib/queries/competitions";
import { COMPETITION_TYPE_LABELS, formatCompetitionDates } from "../../lib/competitionState";
import styles from "./CompetitionContextStrip.module.css";

interface CompetitionContextStripProps {
  competition?: Competition;
}

// The working-context panel at the top of the competition-mode sidebar:
// which competition am I in, when it is, and the way out. See
// docs/mockups/DESIGN.md §"mode-strip".
//
// Deliberately NOT the venue. The strip is read all day by somebody who
// is already working on this competition and knows perfectly well where
// it is; the place matters to whoever is travelling to it, which is the
// Přehled page and the printed startovní listina. `meta` filters falsy
// entries, so dropping it leaves no stray separator.
export function CompetitionContextStrip({
  competition,
}: CompetitionContextStripProps) {
  const meta = [
    competition && COMPETITION_TYPE_LABELS[competition.type],
    competition?.date && formatCompetitionDates(competition),
  ].filter(Boolean) as string[];

  return (
    <div className={styles.strip}>
      <div className={styles.label}>Soutěž</div>
      <div className={styles.title}>
        {competition?.name ?? "…"}
      </div>
      {meta.length > 0 && (
        <div className={styles.meta}>
          {meta.map((m) => (
            <span key={m}>{m}</span>
          ))}
        </div>
      )}
      <Link to="/admin/souteze" className={styles.leave}>
        <ArrowLeft aria-hidden="true" />
        Opustit soutěž
      </Link>
    </div>
  );
}
